export default function Contact(){
    return (
        <section className="contact section" id="contact">
  <div className="container">
    <div className="row">
      <div className="section-title padd-15">
        <h2>Contact</h2>
      </div>
    </div>
    <h3 className="contact-title padd-15">Any questions?</h3>
    <h4 className="contact-sub-title padd-15">I AM AT YOUR SERVICE</h4>
    <div className="row">
      <div className="contact-info-item padd-15">
        <div className="icon"><i className="fa fa-phone"></i></div>
        <h4>Call Me</h4>
        <p>+8801814264333</p>
      </div>
      <div className="contact-info-item padd-15">
        <div className="icon"><i className="fa fa-envelope"></i></div>
        <h4>Email</h4>
        <p>sazidmostafiz2019@gmail.com</p>
      </div>
      <div className="contact-info-item padd-15">
        <div className="icon"><i className="fa fa-envelope"></i></div>
        <h4>Fiverr</h4>
        <p>
          <a
            href="http://www.fiverr.com/sazidmostafizth/buying?source=avatar_menu_profile"
            style={{ textDecoration: "none", color: "var(--text-black-700)" }}
          >
            Sazid Mostafiz
          </a>
        </p>
      </div>
      <div className="contact-info-item padd-15">
        <div className="icon"><i className="fa-brands fa-whatsapp"></i></div>
        <h4>Whatsapp</h4>
        <p>
          <a
            href="https://wa.me/8801814264333"
            style={{ textDecoration: "none", color: "var(--text-black-700)" }}
          >
            Sazid Mostafiz
          </a>
        </p>
      </div>
    </div>

    <h3 className="contact-title padd-15">SEND AN EMAIL</h3>
    <h4 className="contact-sub-title padd-15">I WILL BE HAPPY TO RESPOND</h4>

    <div className="row">
      <div className="contact-form padd-15">
        <form
          target="_parent"
          action="https://formsubmit.co/c4bc8b642f270ec44601803c858b775d"
          method="POST"
        >
          <input type="hidden" name="_next" value="https://sazid-mostafiz-portfolio.web.app/thankyou.html" />
          <input type="text" name="_honey" style={{ display: "none" }} />
          <input type="hidden" name="_template" value="table" />

          <div className="row">
            <div className="form-item col-6 padd-15">
              <div className="form-group">
                <input type="text" className="form-control" placeholder="Name" name="name" required />
              </div>
            </div>
            <div className="form-item col-6 padd-15">
              <div className="form-group">
                <input type="email" className="form-control" placeholder="Email Address" name="email" required />
              </div>
            </div>
            <div className="form-item col-12 padd-15">
              <div className="form-group">
                <input type="text" className="form-control" placeholder="Subject" name="subject" required />
              </div>
            </div>
            <div className="form-item col-12 padd-15">
              <div className="form-group">
                <textarea name="message" className="form-control" rows="8" placeholder="Your message" required />
              </div>
            </div>
            <div className="form-item col-12 padd-15">
              <button type="submit" className="btn">Send Message</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

    )
}